import { AuthConfigProvider } from "@tesla/ng-auth";
import { appConstantsFactory } from "app/app.module";
import { AppSettings } from "../app.settings";
import { isNullOrUndefined } from "util";

const appConstant = appConstantsFactory();
export class Constants {
  private config: AppSettings;
  static Api = class {
    static AuthId = AuthConfigProvider.getCurrentAuthProvider(
      appConstant.openid.id
    );
  };

  static ServiceMethod = class {
    static BaseUrl =
      Constants.Api.AuthId = appConstant.BASE_URL;
    // user details
    static GetUserDetails = "GetUserDetails/";

    // lookups
    static GetSuppliers = "lookup/suppliers";
  };
}

export const BANK_TOKEN = 'BANK-TOKEN'

export const VerificationStatus = {
  PendingVerification: "PENDING_VERIFICATION",
  PendingDeposit: "PENDING_DEPOSIT",
}

export const US_STATE_LIST = [
  'AK','AL','AR','AZ','CA','CO','CT','DC','DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VA','VT','WA','WI','WV','WY'
];

export const constants = {};


export const statusClass = {
  'New': 'primary',
  'Completed': 'success',
  'Rejected': 'warning',
  'Pending': 'warning',
  'Under Tesla Review': 'success'
};

export const statusDisplay = {
  'New': 'New',
  'Completed': 'Completed',
  'Rejected': 'Needs Review',
  'Pending': 'Pending',
  'Under Tesla Review': 'Under Tesla Review'
};

export const isDataUnderReview = (supplierData: any): boolean => {
  var isDataUnderReviewVal = false;
  if (supplierData?.length > 0) {
    supplierData?.forEach(data => {
        var keys = Object.keys(data);
        if(keys.includes('operation') && data['operation']?.newValue != undefined && data['operation']?.newValue != null)
        {
          isDataUnderReviewVal = true;
        }
    }) ;
  }
  
  return isDataUnderReviewVal;
}